import { render, staticRenderFns } from "./AddGroup.vue?vue&type=template&id=a7a5b2ae&scoped=true"
import script from "./AddGroup.vue?vue&type=script&lang=js"
export * from "./AddGroup.vue?vue&type=script&lang=js"
import style0 from "./AddGroup.vue?vue&type=style&index=0&id=a7a5b2ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a5b2ae",
  null
  
)

export default component.exports